import { cn } from '@shadcn/lib/utils';
import { Button as ShadcnButton } from '@shadcn/ui/button';
import { Loader2, LucideIcon } from 'lucide-react';
import React from 'react';

const customAppearanceClasses = {
  primary: 'bg-primary-700 text-white hover:bg-primary-800',
  secondary:
    'bg-neutral-0 text-typography-light border border-secondary-700 font-normal hover:bg-secondary-500 active:bg-secondary-700 ',
};

const customSizeClasses = {
  lg: 'h-[39px] px-[12px] text-md',
  sm: 'h-[29px] px-3 text-sm',
};

export function Button({
  className,
  appearance = 'primary',
  size = 'lg',
  disabled,
  loading,
  children,
  icon: Icon,
  ...props
}: IButtonProps) {
  const customClasses = cn(
    customAppearanceClasses[appearance],
    customSizeClasses[size],
    'cursor-pointer',
    'rounded-[12px]',
    loading && 'bg-primary-300 text-primary-700 cursor-wait',
    !loading && disabled && 'bg-secondary-200 hover:bg-secondary-200 text-secondary-500 cursor-not-allowed',
    className
  );
  return (
    <ShadcnButton
      aria-disabled={disabled || loading}
      className={customClasses}
      disabled={Boolean(disabled || loading)}
      {...props}
    >
      {loading ? <Loader2 className="w-4 h-4 animate-spin" data-testid="loader-2" /> : Icon && <Icon />}
      {children}
    </ShadcnButton>
  );
}

export interface IButtonProps extends React.ComponentProps<typeof ShadcnButton> {
  readonly appearance?: keyof typeof customAppearanceClasses;
  readonly className?: string;
  readonly icon?: LucideIcon;
  readonly loading?: boolean;
  readonly size?: keyof typeof customSizeClasses;
}
